"use strict";
var gallery = document.querySelector(".gallery");
var largeImage = document.querySelector("#largeImg");
gallery.addEventListener("click", function(e) {
    var link = e.target.closest("a");
    if (link) {
        e.preventDefault();
        var newSrc = link === null || link === void 0 ? void 0 : link.href;
        largeImage.src = newSrc;
    }
});

//# sourceMappingURL=index.59cad71a.js.map
